import type { WhitelabelCloudflareHostnameStatus as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

// `hostnameStatus` and `certificateStatus` are free-form Cloudflare values, not enums. `checked: false`
// means Cloudflare was unreachable, so every other field is unknown rather than absent.
export type CloudflareHostnameStatus = {
  role: string;
  checked: boolean;
  host?: string;
  error?: string;
  hostnameRegistered?: boolean;
  hostnameStatus?: string;
  certificateStatus?: string;
  customOriginServer?: string;
  transformRuleCovered?: boolean;
  coverageError?: string;
};

export const fromGql = (item: GQLItem): CloudflareHostnameStatus => ({
  ...take<CloudflareHostnameStatus>(item, 'role', 'checked'),
  host: item.host ?? undefined,
  error: item.error ?? undefined,
  hostnameRegistered: item.hostnameRegistered ?? undefined,
  hostnameStatus: item.hostnameStatus ?? undefined,
  certificateStatus: item.certificateStatus ?? undefined,
  customOriginServer: item.customOriginServer ?? undefined,
  transformRuleCovered: item.transformRuleCovered ?? undefined,
  coverageError: item.coverageError ?? undefined,
});

export const fromGqlCollection = (items: GQLItem[]): CloudflareHostnameStatus[] => items.map(fromGql);
